export const photos = [
  {
    id: "p1",
    title: "秋日私语",
    description: "京都岚山竹林取景，和风造型与自然融合",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20Japanese%20woman%20in%20kimono%20standing%20in%20Kyoto%20bamboo%20forest%20with%20autumn%20maple%20leaves%2C%20soft%20dreamy%20atmosphere%2C%20editorial%20fashion%20photography%2C%20warm%20golden%20lighting%2C%20minimalist%20composition%2C%20traditional%20Japanese%20aesthetic&width=600&height=800&seq=photo-p1&orientation=portrait",
    category: "photo",
  },
  {
    id: "p2",
    title: "都市光影",
    description: "东京夜景街拍，时尚都市风格",
    imageUrl: "https://readdy.ai/api/search-image?query=Japanese%20fashion%20model%20in%20elegant%20black%20dress%20at%20Tokyo%20night%20street%20with%20city%20lights%20bokeh%2C%20sophisticated%20urban%20style%2C%20editorial%20photography%2C%20warm%20neon%20glow%2C%20minimalist%20composition&width=600&height=800&seq=photo-p2&orientation=portrait",
    category: "photo",
  },
  {
    id: "p3",
    title: "夏日花语",
    description: "向日葵花田中的清新夏日造型",
    imageUrl: "https://readdy.ai/api/search-image?query=Japanese%20woman%20in%20white%20summer%20dress%20standing%20in%20sunflower%20field%20under%20blue%20sky%2C%20fresh%20natural%20summer%20vibe%2C%20soft%20sunlight%2C%20editorial%20fashion%20photography%2C%20minimalist%20composition&width=600&height=800&seq=photo-p3&orientation=portrait",
    category: "photo",
  },
  {
    id: "p4",
    title: "樱花季",
    description: "春天的樱花树下，温柔浪漫的粉色主题",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20Japanese%20woman%20in%20pink%20kimono%20under%20cherry%20blossom%20trees%20in%20full%20bloom%2C%20spring%20romantic%20atmosphere%2C%20soft%20pink%20petals%20falling%2C%20editorial%20photography%2C%20dreamy%20pastel%20tones&width=600&height=800&seq=photo-p4&orientation=portrait",
    category: "photo",
  },
  {
    id: "p5",
    title: "海边的风",
    description: "冲绳海边取景，清新自然的度假风格",
    imageUrl: "https://readdy.ai/api/search-image?query=Japanese%20woman%20in%20flowing%20blue%20dress%20on%20tropical%20beach%20at%20sunset%2C%20ocean%20waves%20in%20background%2C%20warm%20golden%20hour%20lighting%2C%20editorial%20fashion%20photography%2C%20minimalist%20composition&width=600&height=800&seq=photo-p5&orientation=portrait",
    category: "photo",
  },
  {
    id: "p6",
    title: "午后阳光",
    description: "咖啡馆午后慵懒时光",
    imageUrl: "https://readdy.ai/api/search-image?query=Japanese%20woman%20in%20casual%20knitwear%20sitting%20by%20window%20in%20cozy%20cafe%2C%20soft%20afternoon%20sunlight%2C%20warm%20coffee%20on%20table%2C%20lifestyle%20editorial%20photography%2C%20minimalist%20composition&width=600&height=800&seq=photo-p6&orientation=portrait",
    category: "photo",
  },
];

export const featuredVideos = [
  {
    id: "v1",
    title: "《天使之恋》",
    role: "主演 · 小泽理央",
    year: "2009",
    imageUrl: "https://readdy.ai/api/search-image?query=Romantic%20Japanese%20movie%20poster%20style%20with%20young%20couple%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20white%20aesthetic%2C%20cinematic%20lighting%2C%20high%20school%20romance%20theme%2C%20clean%20composition&width=600&height=400&seq=featured-v1&orientation=landscape",
    category: "drama",
  },
  {
    id: "v2",
    title: "《FIRST CLASS》",
    role: "出演 · 松岛美织",
    year: "2014",
    imageUrl: "https://readdy.ai/api/search-image?query=Fashion%20magazine%20office%20setting%20Japanese%20drama%20style%2C%20modern%20professional%20women%20in%20elegant%20office%20wear%2C%20warm%20lighting%2C%20cinematic%20composition%2C%20minimalist%20fashion%20aesthetic&width=600&height=400&seq=featured-v2&orientation=landscape",
    category: "drama",
  },
  {
    id: "v3",
    title: "《东京机场管制保全局》",
    role: "出演 · 藤井夏海",
    year: "2012",
    imageUrl: "https://readdy.ai/api/search-image?query=Airport%20control%20tower%20with%20sunset%20sky%2C%20professional%20Japanese%20woman%20looking%20at%20runway%2C%20cinematic%20drama%20aesthetic%2C%20warm%20golden%20lighting%2C%20minimalist%20composition&width=600&height=400&seq=featured-v3&orientation=landscape",
    category: "drama",
  },
  {
    id: "v4",
    title: "《世界奇妙物语》",
    role: "主演 · 春季特别篇",
    year: "2015",
    imageUrl: "https://readdy.ai/api/search-image?query=Mysterious%20fantasy%20Japanese%20drama%20scene%20with%20woman%20in%20ethereal%20white%20dress%2C%20soft%20glowing%20lights%2C%20surreal%20atmosphere%2C%20cinematic%20lighting%2C%20minimalist%20composition&width=600&height=400&seq=featured-v4&orientation=landscape",
    category: "drama",
  },
];